import { gql, QueryHookOptions, useQuery } from "@apollo/client";
import { graphql } from "~/gql";
import { findAllLibraryUplifts } from "../__generated_types__/findAllLibraryUplifts";

export const FIND_ALL_LIBRARY_UPLIFTS = graphql(/* GraphQL */ `
  query findAllLibraryUplifts {
    findAllLibraryUplifts {
      id
      reason
      group
    }
  }
`);

export function useLibraryUpliftsQuery(options?: QueryHookOptions<findAllLibraryUplifts>) {
  return useQuery<findAllLibraryUplifts>(FIND_ALL_LIBRARY_UPLIFTS, options);
}
